import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {IAssignedPhotoCategory, IPhotoCategory} from './photo-category';
import {MIHttpClientService} from '../../shared/mi-http-client.service';
import {IFormDefinition, IFormField} from '../builder/formDefinition';


@Injectable({
  providedIn: 'root',
})
export class PhotoCategoryService {

  constructor(
    private miClient: MIHttpClientService,
  ) {
  }

  getPhotoCategories(): Observable<IPhotoCategory[]> {
    return this.miClient.get<IPhotoCategory[]>('photos/categories');
  }

  getPublicFormPhotoCategories(guid): Observable<IPhotoCategory[]> {
    return this.miClient.get<IPhotoCategory[]>(`public-forms/${guid}/photo-categories`, {}, false);
  }

  createPhotoCategory(item: any): Observable<any> {
    return this.miClient.post('photos/categories', item);
  }

  getPhotoCategoryDetails(id: number): Observable<IPhotoCategory> {
    return this.miClient.get<any>('photos/categories/' + id);
  }

  updatePhotoCategory(item: any): Observable<any> {
    return this.miClient.post('photos/categories/' + item.id, item);
  }

  deletePhotoCatogory(id: number): Observable<void> {
    return this.miClient.delete<void>('photos/categories/' + id);
  }


}
